<template>
  <div :class="$style.releaseCard">
    <p v-if="content.date" :class="$style.date">
      {{ $d(new Date(content.date), 'longDate') }}
    </p>
    <PLink :simple-url="formatedLink" :class="$style.titleLink">
      <Title
        :title-params="content.article_title"
        is-title
        :class="$style.title"
      />
    </PLink>
    <RichText
      :text-params="content.article_introduction"
      :class="$style.desc"
    />
    <PLink :simple-url="formatedLink" is-highlight :class="$style.link">
      {{ $t('readMore') }}
    </PLink>
  </div>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'
import linkResolver from '~/utils/prismic/link-resolver'

export default {
  name: 'ReleaseCard',

  components: {
    Title,
    RichText,
    PLink,
  },

  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    content() {
      return this.article.data
    },

    formatedLink() {
      return linkResolver({ ...this.article, link_type: 'Document' })
    },
  },
}
</script>

<style lang="scss" module>
.releaseCard {
  padding: 25px;
  border-radius: 8px;

  transition: all 0.3s ease-in-out;

  &:hover {
    box-shadow: 3px 3px 10px $gray-200;
    transform: translateY(-2px);
  }
}

.date {
  color: $gray-300;
  font-weight: 500;
  text-transform: uppercase;
}

.titleLink {
  text-decoration: none;
}

.title {
  margin-top: 8px;
}

.desc {
  margin-top: 8px;

  color: $gray-700;
}

.link {
  margin-top: 24px;
}
</style>
